import { ISchedule } from './interfaces'
import { CronDate, parseExpression } from 'cron-parser'
import { ValidTimeZone } from '@iotv/iotv-v3-types'
import { defaultTZ } from '../../../selectedConfig'
import { v4 } from 'uuid'
import { CronScheduleProps } from './types'

const debug = !process.env.AWS_SESSION_TOKEN && false

// https://regexr.com/4jp54
export const cronRegexp =
  /(@(annually|yearly|monthly|weekly|daily|hourly|reboot))|(@every (\d+(ns|us|µs|ms|s|m|h))+)|((((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*) ?){5,7})/

export type ICronSchedule = ISchedule & { cronStr: string }

export class CronSchedule implements ICronSchedule {
  constructor({ cronStr, id }: CronScheduleProps) {
    if (cronRegexp.test(cronStr)) {
      this.cronStr = cronStr
      this.id = id ?? v4()
    } else {
      throw new Error(`invalid cron string: ${cronStr}`)
    }
  }

  id: string
  cronStr: string
  disallowAllAny: boolean = true

  cronStrMinsHoursAreAny = (s: string) => {
    const cronArr = s.split(' ')

    const isAllAny = cronArr.slice(0, 2).some((x) => x === '*')
    return isAllAny
  }

  getOccurances = (fromMs: number, toMs: number, tz?: ValidTimeZone) => {
    const options = {
      currentDate: new Date(fromMs).toUTCString(),
      endDate: new Date(toMs).toUTCString(),
      iterator: true,
      tz: tz ?? defaultTZ,
    }

    const res: number[] = []

    if (this.cronStr) {
      if (this.disallowAllAny && !this.cronStrMinsHoursAreAny(this.cronStr)) {
        const interval = parseExpression(this.cronStr, options)
        while (interval.hasNext()) {
          try {
            const tick = interval.next() as IteratorResult<CronDate, CronDate> // typing give CronDate | IteratorResult<CronDate, CronDate>
            res.push(tick.value.toDate().valueOf())
          } catch (e: any) {
            console.log('Err in cron interval', e.message)
            throw e
          }
        }
        debug && console.log(`no more next() with ${this.cronStr} between ${options.currentDate} and ${options.endDate} in tz ${options.tz}`)
      } else {
        debug && console.log('Disallowed all any with', this.cronStr)
      }
    } else {
      console.log('WARN no cron string')
    }

    return res
  }
}
